import React, { useState, Fragment, useEffect, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import FoodsList from "./FoodsList"
import FoodsSearch from "./FoodsSearch"
import FoodsSectionList from "./FoodsSectionList"
import FoodsCategories from "./FoodsCategories"
import FoodsFloatTablesButton from "./FoodsFloatTablesButton"
import { hideFoodSearchBar, showFoodSearchBar } from "@redux"
import classes from "./index.module.scss"

const Foods = () => {
  const i18n = useTranslation()[1]

  const dispatch = useDispatch()

  const systemSettings =
    useSelector(state => state.systemSettings)

  const foodPageUiState =
    useSelector(state => state.foodPageUiState)

  const [searchedFoods, setSearchedFoods] = useState(null)

  const handleAutoOpenSearchbar =
    useCallback((e) => {
      const isModalOpen =
        !!document.getElementById("modal")

      const isPinModalOpen =
        !!document.getElementById("pin-modal")

      if (isModalOpen) return

      if (isPinModalOpen) return

      if (e.key === "Escape") {
        dispatch(hideFoodSearchBar())

        return
      }

      if (e.key.length !== 1) return

      dispatch(showFoodSearchBar())
    }, [])

  useEffect(() => {
    window.addEventListener("keydown", handleAutoOpenSearchbar)

    return () => {
      window.removeEventListener("keydown", handleAutoOpenSearchbar)
    }
  }, [])

  const dir = i18n.dir(i18n.language)

  const showFloatTablesButton =
    systemSettings.serviceTypeName === "restaurant" &&
    !!systemSettings.deliveryTypeOptions?.dineIn

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div
          className={clsx(
            classes["right-side"], dir === "ltr" && classes["right-side-ltr"])
          }
        >
          {foodPageUiState.searchBar
            ?
            <Fragment>
              <FoodsSearch
                setSearchedFoods={setSearchedFoods}
              />

              <FoodsList
                searchedFoods={searchedFoods}
              />
            </Fragment>
            :
            <Fragment>
              <FoodsCategories />

              <FoodsSectionList />
            </Fragment>
          }
        </div>

        {
          showFloatTablesButton &&
          <FoodsFloatTablesButton />
        }
      </div>
    </Fragment>
  )
}

export default Foods